export default function File({ selected, callback, children, multiple, enabled=true }) {
    return <li key={children+selected} className={"file" + (selected ? " file-selected" : "") + (enabled ? " file-clickable" : "")} onClick={enabled ? callback : ()=>{}}>
        {multiple && <input key={selected} type="checkbox" checked={selected} onChange={callback} enabled={enabled}/>}<span className="filename">{children}</span>
    </li>
}